/* Login Thrown */
export const LOGIN_THROW_UNIQUE_ID_SERVICE = '100000'
export const LOGIN_THROW_ENDPOINT_MISSED = { code: '001', message: 'API REQUEST object han invalid ENDPOINT properties' }
export const LOGIN_THROW_SIGN_MISSED = { code: '002', message: 'API REQUEST object han invalid SIGN properties'}

/* Report Loader Thrown */
export const REPORTLOADER_THROW_UNIQUE_ID_SERVICE = '200000'